import { render, staticRenderFns } from "./NewsListing.vue?vue&type=template&id=13d4f4ce&scoped=true"
import script from "./NewsListing.vue?vue&type=script&lang=js"
export * from "./NewsListing.vue?vue&type=script&lang=js"
import style0 from "./NewsListing.vue?vue&type=style&index=0&id=13d4f4ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d4f4ce",
  null
  
)

export default component.exports